import { Suspense, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SearchModal from './SearchModal';
import ErrorBoundary from '../ErrorBoundary';
import PageLoader from '../PageLoader';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';

export default function PublicLayout() {
  const [searchOpen, setSearchOpen] = useState(false);
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const { setTheme } = useTheme();

  // La tienda minorista es siempre clara: no hay modo oscuro. Se fuerza el tema
  // claro mientras se esté en la tienda (el toggle vive solo en mayorista/admin).
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    setTheme('light');
  }, [setTheme]);

  // OJO con las llaves: sin ellas el efecto devuelve lo que devuelva scrollTo, y
  // React toma ese valor como función de limpieza. Si no es una función, revienta
  // en la SIGUIENTE navegación con "n is not a function".
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Un mayorista logueado solo ve la tienda mayorista: si cae en la tienda
  // minorista, se lo manda directo a /mayorista.
  if (!loading && user?.role === 'mayorista') {
    return <Navigate to="/mayorista" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <ErrorBoundary name="Navbar" silent>
        <Navbar onSearchOpen={() => setSearchOpen(true)} />
      </ErrorBoundary>
      <main className="flex-1">
        <ErrorBoundary key={pathname} name="Outlet" compact>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>
      <ErrorBoundary name="Footer" silent>
        <Footer />
      </ErrorBoundary>
      <ErrorBoundary name="SearchModal" silent>
        <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
      </ErrorBoundary>
    </div>
  );
}
